import { StoreContext } from '@/components/Store';
import { getMenus } from '@/services/HomeService';
import { getSessionIdForCart } from '@/services/StorageService';
import { useContext, useEffect, useState } from 'react';

export const useInitialAppData = () => {
  const { menuState, homeProductState, homeBannerState, featureStoryState, cartState } = useContext(StoreContext);
  const [menus, setMenus] = menuState;
  const setCart = cartState[1];
  const setFeatureStories = featureStoryState[1];
  const setHomeProducts = homeProductState[1];
  const setHomeBanner = homeBannerState[1];
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (menus.length > 0) return;
      setIsLoading(true);
      try {
        const sessionId = getSessionIdForCart();
        const data = await getMenus(sessionId);
        if (data?.menus?.length) setMenus(data.menus);
        if (data?.products?.length) setHomeProducts(data.products.slice(0, 4));
        if (data?.settings) setHomeBanner(data.settings.headerBanner);
        if (data?.featureStories?.length) setFeatureStories(data.featureStories);
        if (data?.cart) setCart(data?.cart);
      } catch (err) {
        console.error('Failed to fetch menus:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return { isLoading, menus };
};
